import { Capacitor } from '@capacitor/core';

const API_BASE = import.meta.env.VITE_API_URL || 'https://compostdeveloper.com';

/**
 * Resolve API URL for native vs web.
 * On native (Capacitor), the app loads from local files so fetch('/api/...') won't work.
 * We prefix with the remote API base URL.
 * On web, relative URLs work because same-origin or proxied by Vite.
 */
export function apiUrl(path: string): string {
  // Native always needs an absolute API host. When VITE_API_URL is set explicitly
  // (e.g. cloud/local UI against production), use it for web too instead of the Vite proxy.
  if (Capacitor.isNativePlatform() || import.meta.env.VITE_API_URL) {
    return `${API_BASE}${path}`;
  }
  return path;
}
